import { Link } from "react-router-dom";
import PageLayout from "../components/layout/PageLayout";
import { Trophy, Camera, Shield, Building2, Sparkles, BarChart3, Zap, Users, Book, Star } from "lucide-react";
import { HERO_IMAGES } from "../lib/constants";

const SERVICES = [
    { icon: Trophy, title: "Athlete Brand Development", desc: "Identity, message, image, visual style and long-term brand positioning tailored to who you are.", items: ["Brand identity & guidelines", "Story & narrative", "Visual style guide", "Positioning & audience"] },
    { icon: Camera, title: "Social Media Management", desc: "Full-service content operations across Instagram, TikTok, YouTube, X, Twitch and more.", items: ["Content strategy & calendar", "Copywriting & captions", "Community management", "Scheduling & analytics"] },
    { icon: Shield, title: "NIL Deal Representation", desc: "End-to-end deal management — from lead to payment — with compliance built in.", items: ["Contract negotiation", "Compliance & approvals", "Deliverables tracking", "Payment reconciliation"] },
    { icon: Building2, title: "Sponsorship Acquisition", desc: "We open doors to brands, businesses, events and community organizations.", items: ["Sponsor prospecting", "Pitch decks & media kits", "Campaign proposals", "Relationship management"] },
    { icon: Sparkles, title: "Content Production", desc: "Cinematic photo, video, interviews, graphics and short-form content that stops the scroll.", items: ["Photo & video shoots", "Podcast & interview", "Short-form editing", "Graphics & thumbnails"] },
    { icon: BarChart3, title: "Long-Term Business Development", desc: "Merchandise, camps, appearances, licensing, entrepreneurship and life after sports.", items: ["Merch & licensing", "Camps & clinics", "Appearances & speaking", "Post-athletic career planning"] },
];

export default function Services() {
    return (
        <PageLayout>
            <section className="relative min-h-[50vh] flex items-end pb-16 pt-32 overflow-hidden border-b border-white/10">
                <img src={HERO_IMAGES.training} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
                <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent" />
                <div className="relative z-10 max-w-[1400px] mx-auto px-5 md:px-10 w-full">
                    <div className="section-label mb-5">Athlete Services</div>
                    <h1 className="font-display text-5xl md:text-7xl text-white leading-none tracking-tight" data-testid="services-heading">
                        EVERY ANGLE.<br/><span className="text-[#d4af37]">ONE HOUSE.</span>
                    </h1>
                </div>
            </section>
            <section className="py-16 md:py-24">
                <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid md:grid-cols-2 gap-4">
                    {SERVICES.map(({ icon: I, title, desc, items }) => (
                        <div key={title} className="surface surface-hover p-8" data-testid={`svc-${title.toLowerCase().replace(/\s+/g,'-')}`}>
                            <I className="text-[#d4af37]" size={30} strokeWidth={1.5} />
                            <div className="font-display text-3xl mt-6 text-white leading-tight">{title}</div>
                            <p className="text-white/60 mt-4 leading-relaxed">{desc}</p>
                            <ul className="mt-6 space-y-2">
                                {items.map(it => (
                                    <li key={it} className="text-white/70 text-sm flex items-start gap-3">
                                        <Zap size={12} className="text-[#d4af37] mt-1 flex-shrink-0" /> {it}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
                <div className="max-w-[1400px] mx-auto px-5 md:px-10 mt-16 text-center">
                    <Link to="/apply" className="btn-gold" data-testid="services-apply">Apply for Representation</Link>
                </div>
            </section>
        </PageLayout>
    );
}
